// assets/js/vendor.js
import utilitiesAll from './utilities/utilitiesAll';

// 初期化
document.addEventListener('DOMContentLoaded', async () => {
  await utilitiesAll(); // 非同期処理をサポート
});
